import React, { useState } from "react";
import AddButton from "@core/buttons/atoms/AddButton";
import AddModal from "@core/modals/AddModal";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import SubAreaSelect from "@components/SubArea/partials/SubAreaSelect";
import StatisticalDivisionService from "@services/StatisticalDivisionService";

const CreateStatisticalDivision = ({ onAdded }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedSubArea, setSelectedSubArea] = useState();

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setSelectedSubArea("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    StatisticalDivisionService.create(
      name,
      englishName,
      description,
      selectedSubArea
    )
      .then(() => {
        showSuccess(t("StatisticalDivisionCreatedSuccessfully"));
        closeModal();
        onAdded();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"create_statistical_division"}>
      <AddButton
        label={t("addStatisticalDivision")}
        onClick={() => setShowModal(true)}
      />
      <AddModal
        show={showModal}
        title={t("addStatisticalDivision")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-xs font-semibold mb-2 flex">
              {t("subArea")}
            </div>
            <SubAreaSelect
              openModal={showModal}
              onSelect={setSelectedSubArea}
              selected={selectedSubArea}
            />
          </div>
        </div>
      </AddModal>
    </PermissionHandler>
  );
};

export default CreateStatisticalDivision;
